import globals from'../globals.js';

import load_image from'../helpers/image-loader.js';
import load_video from'../helpers/video-loader.js';

function expand(){

    var expandTrigger = document.querySelectorAll('.exp-trig');
    var expTrig = Array.prototype.slice.call(expandTrigger);

    expTrig.forEach(function(trig) {

        var parent = trig.parentNode;
        var content = parent.querySelectorAll('.exapnding-intro')[0];
        var state = false;
        
        trig.addEventListener('click', function(e){

            if(!state){
                state = true;
                for (let a = 0; a < content.children.length; a++) {
                    let elm = content.children[a];
                    elm.classList.add('show'); 
                }
                trig.innerHTML = '(close)';
            }else{
                state = false;
                for (let a = 0; a < content.children.length; a++) {
                    let elm = content.children[a];
                    elm.classList.remove('show'); 
                }
                trig.innerHTML = 'read more...';
            }
           

        });

    });

};

export default expand;